/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import {
  DeploymentStatus,
  DeploymentStatus$outboundSchema,
} from "./deploymentstatus.js";

/**
 * Filter deployments within a workspace. All filters are optional; with none
 *
 * @remarks
 * set, every deployment in the workspace is returned, newest first.
 */
export type V1DeploymentsListDeploymentsRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project?: string | undefined;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app?: string | undefined;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment?: string | undefined;
  /**
   * Restrict results to deployments in any of the given lifecycle statuses.
   *
   * @remarks
   * Omit to return deployments in every status.
   */
  status?: Array<DeploymentStatus> | undefined;
  /**
   * Maximum number of deployments to return per request.
   *
   * @remarks
   * Balance between response size and number of pagination calls needed.
   */
  limit?: number | undefined;
  /**
   * Pagination cursor from a previous response to fetch the next page.
   *
   * @remarks
   * Use when `hasMore: true` in the previous response.
   */
  cursor?: string | undefined;
};

/** @internal */
export type V1DeploymentsListDeploymentsRequestBody$Outbound = {
  project?: string | undefined;
  app?: string | undefined;
  environment?: string | undefined;
  status?: Array<string> | undefined;
  limit: number;
  cursor?: string | undefined;
};

/** @internal */
export const V1DeploymentsListDeploymentsRequestBody$outboundSchema: z.ZodType<
  V1DeploymentsListDeploymentsRequestBody$Outbound,
  z.ZodTypeDef,
  V1DeploymentsListDeploymentsRequestBody
> = z.object({
  project: z.string().optional(),
  app: z.string().optional(),
  environment: z.string().optional(),
  status: z.array(DeploymentStatus$outboundSchema).optional(),
  limit: z.number().int().default(100),
  cursor: z.string().optional(),
});

export function v1DeploymentsListDeploymentsRequestBodyToJSON(
  v1DeploymentsListDeploymentsRequestBody:
    V1DeploymentsListDeploymentsRequestBody,
): string {
  return JSON.stringify(
    V1DeploymentsListDeploymentsRequestBody$outboundSchema.parse(
      v1DeploymentsListDeploymentsRequestBody,
    ),
  );
}
